(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  let observer;

  const initReveal = (root = document) => {
    const items = root.querySelectorAll('[data-bf-reveal]:not([data-bf-ready])');
    if (reduce.matches) {
      items.forEach((item) => {
        item.dataset.bfReady = 'true';
        item.classList.add('is-visible');
      });
      return;
    }
    if (!observer) {
      observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -5% 0px' });
    }
    items.forEach((item) => {
      item.dataset.bfReady = 'true';
      observer.observe(item);
    });
  };

  const initTilt = (root = document) => {
    if (reduce.matches || !window.matchMedia('(pointer:fine)').matches) return;
    root.querySelectorAll('[data-bf-tilt]:not([data-bf-tilt-ready])').forEach((item) => {
      item.dataset.bfTiltReady = 'true';
      item.addEventListener('pointermove', (event) => {
        const rect = item.getBoundingClientRect();
        const x = (event.clientX - rect.left) / rect.width - 0.5;
        const y = (event.clientY - rect.top) / rect.height - 0.5;
        item.style.transform = 'perspective(1200px) rotateX(' + (-y * 5).toFixed(2) + 'deg) rotateY(' + (x * 7).toFixed(2) + 'deg) translateY(-4px)';
      });
      item.addEventListener('pointerleave', () => {
        item.style.transform = '';
      });
    });
  };

  const initDropdownNavigation = (root = document) => {
    root.querySelectorAll('[data-bf-dropdown-nav]:not([data-bf-dropdown-ready])').forEach((nav) => {
      nav.dataset.bfDropdownReady = 'true';
      const details = [...nav.querySelectorAll('.bf-dropdown-nav__details')];
      let closeTimer;
      const closeOthers = (keep) => details.forEach((item) => { if (item !== keep) item.removeAttribute('open'); });

      details.forEach((item) => {
        const trigger = item.querySelector(':scope > summary');
        if (window.matchMedia('(pointer:fine)').matches) {
          item.addEventListener('pointerenter', () => {
            window.clearTimeout(closeTimer);
            closeOthers(item);
            item.setAttribute('open', '');
          });
          item.addEventListener('pointerleave', () => {
            closeTimer = window.setTimeout(() => item.removeAttribute('open'), 140);
          });
        }
        trigger?.addEventListener('click', (event) => {
          if (event.detail > 0 && window.matchMedia('(pointer:fine)').matches && item.open) {
            event.preventDefault();
          }
          closeOthers(item);
        });
      });

      document.addEventListener('pointerdown', (event) => {
        if (!nav.contains(event.target)) closeOthers();
      });
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') closeOthers();
      });
    });
  };

  const init = (root = document) => {
    initReveal(root);
    initTilt(root);
    initDropdownNavigation(root);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();